import { styled } from "@/root/stitches.config";
import LogoImage from "@/assets/logo.svg";
import { Link } from "@inertiajs/react";
import { useWindowSize } from "@uidotdev/usehooks";

import useNavbar from "@/hooks/useNavbar";

const Logo = styled("img", {
    display: "block",
    objectFit: "cover",
    objectPosition: "center",
    width: 75,
});

export default function NavbarLogo() {
    const { width } = useWindowSize();

    const {
        links: { homeUrl },
    } = useNavbar();

    if (width <= 768) {
        return null;
    }

    return (
        <Link href={homeUrl}>
            <Logo
                src={LogoImage}
                alt="Logo"
                css={{
                    width: width < 768 ? 55 : 75,
                }}
            />
        </Link>
    );
}